import React from 'react';
import styled from 'styled-components';

interface ContainerProps {
  type?: string;
  backgroundColor?: string;
  fontColor?: string;
  border?: string;
  width?: string;
  borderRadius?: string;
  marginTop?: string;
  marginLeft?: string;
  display?: string;
  disabled?: boolean;
}

interface ButtonProps extends ContainerProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  text?: string;
}

const Container = styled.div<ContainerProps>`
  height: 40px;
  color: ${props => props.fontColor};
  width: ${props => props.width};
  background: ${props => props.backgroundColor};
  border-radius: ${props => props.borderRadius};
  border: ${props => props.border};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${props => props.marginTop};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-left: ${props => props.marginLeft};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
`;

const Button: React.FC<ButtonProps> = props => {
  return (
    <Container
      type={props.type}
      backgroundColor={props.backgroundColor}
      fontColor={props.fontColor}
      border={props.border}
      width={props.width}
      borderRadius={props.borderRadius}
      onClick={props.onClick}
      marginTop={props.marginTop}
      marginLeft={props.marginLeft}
      display={props.display}
    >
      <Text>{props.text}</Text>
    </Container>
  );
};

Button.defaultProps = {
  text: 'default',
  fontColor: 'white',
  backgroundColor: '#388fc0',
  width: '100px',
  borderRadius: '5px',
  border: '1px solid #388fc0'
};

export default Button;
